<template>
  <footer>
    <b-navbar toggleable type="light">
      <b-container>
        <b-collapse id="footer" is-nav>
          <b-navbar-nav class="ml-auto">
            <b-nav-item
              v-for="item in footerMenu"
              :key="item.id"
              :to="item.link"
            >
              {{ item.text }}
            </b-nav-item>
            <!-- <b-nav-item @click="openModal(modalName('new'))">{{ $t('pages.prescriber.new') }}</b-nav-item> -->
            <social-sharing :title="$t('footer.invitation.title')"
                            :quote="$t('footer.invitation.title')"
                            :url="getShareLink()"
                            inline-template>
              <div class="d-flex vertical-align-middle social-sharing">
                <network network="facebook">
                  <icon name="facebook" scale="1" />
                </network>
                <network network="twitter">
                  <icon name="twitter" scale="1" />
                </network>
              </div>
            </social-sharing>
          </b-navbar-nav>
        </b-collapse>
      </b-container>
    </b-navbar>
    <cookie-law :button-text="$t('cookie_button_text')" :message="$t('cookie_button_message')" theme="blood-orange" />
  </footer>
</template>

<script>
  import SocialSharing from 'vue-social-sharing';
  import CookieLaw from '@triotech/vue-core/src/vendor/vue-cookie-law';
  /* eslint-disable import/no-extraneous-dependencies */
  import 'vue-awesome/icons/facebook';
  import 'vue-awesome/icons/twitter';
  /* eslint-enable import/no-extraneous-dependencies */

  export default {
    name: 'EFooterComponent',
    components: {
      SocialSharing,
      CookieLaw,
    },
    data() {
      return {
        footerMenu: [{
          link: { name: 'cgv' },
          text: this.$t('footer.cgv'),
        }, {
          link: { name: 'contact' },
          text: this.$t('footer.contact'),
        }, {
          link: { name: 'faq' },
          text: this.$t('footer.faq'),
        }, {
          link: { name: 'become_prescriber' },
          text: this.$t('footer.prescriber'),
        }],
      };
    },
    methods: {
      modalName(action) {
        return `presciber-${action}`;
      },
      openModal(id, data = null) {
        this.$bus.$emit(`t-event.t-modal.${id}.open`, data);
      },
      getShareLink() {
        return `${window.location.protocol}//${window.location.host}${this.$router.resolve({ name: 'home' }).href}`;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '~@/scss/vars';
  @import '~@/scss/media';

  /deep/ .modal-form {
    overflow: auto;

    .sweet-modal {
      top: 760px;
      max-height: none;
      margin-bottom: 25px;
    }
  }

  footer {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;

    .navbar {
      padding: 20px;

      /deep/ .social-sharing {
        span {
          padding: .5rem;
          color: $grey;

          &:hover {
            cursor: pointer;
          }
        }
      }
    }
  }

  @include editable-max-width(765px) {
    .navbar {
      justify-content: space-between;
    }

    .navbar-collapse {
      display: flex !important;

      .navbar-nav {
        flex-direction: row;
        width: 100%;
        margin-left: 0;
        flex-wrap: wrap;
        justify-content: center;

        li.nav-item {
          padding: 0 10px;
        }
      }
    }
  }

  @include editable-max-width(600px) {
    /deep/ .modal-form {
      .sweet-modal {
        top: $nav-height;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/EFooter.vue